import { useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const HowToChooseRouter = (): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClosePopup = () => {
        setIsOpen(false);
    };

    const handleOpenPopup = () => {
        setIsOpen(true);
    };

    return (
        <>
            <ControlElement
                type={'large'}
                Icon={InfoCircleFlip}
                onClick={handleOpenPopup}
            >
                Как выбрать роутер
            </ControlElement>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <TextWrapper>
                        <H3 style={{ marginRight: 45 }}>Как выбрать роутер?</H3>
                        <Paragraph4 $color={COLORS.TextInfo}>
                            Роутеры, которые мы&nbsp;продаём, отлично подойдут для любого тарифа: они быстрые, надёжные и&nbsp;используют технологию Wi-Fi 6.
                        </Paragraph4>
                        <Paragraph4 $color={COLORS.TextInfo} as={'ol'}>
                            <b>Главное, на что стоит обратить внимание при выборе роутера:</b>
                            <li>1. Площадь покрытия</li>
                            <li>2. Максимальное количество устройств, которые можно одновременно подключить к&nbsp;роутеру</li>
                        </Paragraph4>
                    </TextWrapper>

                    <ButtonGroup>
                        <Button bType={'action'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                    </ButtonGroup>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};

export default HowToChooseRouter;
